// Default React, React Components, Router and Services Components
import React, { useEffect, useRef, useState } from "react";
import { Box, Grid, Paper, Tooltip, Typography } from "@mui/material";
import BaseLayout from "components/commonComponents/baseLayout";
import Gridnav from "components/commonComponents/gridnav/gridnav";
import MaterialUIModal from "components/commonComponents/modal/modal";
import MaterialUIButton from "components/commonComponents/button/button";
import AgGrid from "components/commonComponents/grid/agGrid";
import UsePagination from "components/commonComponents/pagination/pagination";
import useStyles from "./qcReports.styles";
import FilterListOutlinedIcon from "@mui/icons-material/FilterListOutlined";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { setBauFilter, setProviderFilter } from "redux/app/actions";
import Toasts from "components/commonComponents/toasts/toasts";
import Spinner from "components/commonComponents/spinner/spinner";
import { useLocation } from "react-router-dom";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import { TabContext, TabList, TabPanel } from "@material-ui/lab";
import { Tab } from "@material-ui/core";
import { header, headerBau } from "./Data";
import { utils } from "xlsx/xlsx";
import { writeFile } from "xlsx";
import {
  getBAUList,
  getBAUListExport,
  getPoviderList,
  getPoviderListExport,
} from "redux/qcreports/action";
import AdvanceFilterBau from "./advanceFilterBau";
import AdvanceFilters from "./advanceFilters";
import { qcReports, statusCode } from "utils/enums";
function QcReports() {
  const dispatch = useDispatch();
  const gridApi = useRef(null);
  const id = useSelector((state) => state.project.reports);
  const data = useSelector((state) => state.manageIssue);
  const [load, setLoad] = useState(true);
  const [show, setShow] = useState(false);
  const [search, setSearch] = useState("");
  const [searchBau, setSearchBau] = useState("");
  const [limit, setLimit] = useState(25);
  const [page, setPage] = useState(1);
  const [pageCount, setpageCount] = useState(0);
  const [total, settotal] = useState(0);
  const [totalCount, settotalCount] = useState(0);
  const [totalRecords, settotalRecords] = useState(0);
  const [selectExport, setselectExport] = useState([]);
  const [limitBau, setLimitBau] = useState(25);
  const [pageBau, setPageBau] = useState(1);
  const [pageCountBau, setpageCountBau] = useState(0);
  const [totalBau, settotalBau] = useState(0);
  const [totalCountBau, settotalCountBau] = useState(0);
  const [totalRecordsBau, settotalRecordsBau] = useState(0);
  const [selectExportBau, setselectExportBau] = useState([]);
  const [rows, setRows] = useState();
  const [rowsBau, setRowsBau] = useState();
  const [edit, setEdit] = useState([]);
  const [Data, setData] = useState([]);
  const [bauData, setBAUData] = useState([]);
  const [advFilterOpen, setAdvFilterOpen] = useState(false);
  const [advFilterOpenBau, setAdvFilterOpenBau] = useState(false);
  const classes = useStyles();
  const [showBAU, setshowBAU] = useState(false);

  const [message, setMessage] = useState("");
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const [add, setAdd] = useState([]);
  const selector = JSON.parse(localStorage.getItem("roleData"));
  const filterData = useSelector((state) => state.qcreports.filterProvider);
  const filterDataBau = useSelector((state) => state.qcreports.filterBau);

  const filterBody = {
    region: filterData.region?.map((e) => e),
    rawProviderName: filterData.rawProviderName?.map((e) => e),
    normalizedProviderName: filterData.normalizedProviderName?.map((e) => e),
    exportId: [],
  };
  const filterBodyBau = {
    bauId: filterDataBau.bauId?.map((e) => e),
    oemId: filterDataBau.oemId?.map((e) => e),
    make: filterDataBau.make?.map((e) => e),
    region: filterDataBau.region?.map((e) => e),
    uploaded: filterDataBau.uploaded?.map((e) => e),
    utf8Status: filterDataBau.utf8Status?.map((e) => e),
    qcStatus: filterDataBau.qcStatus?.map((e) => e),
    uploadStatusServiceBus: filterDataBau.uploadStatusServiceBus?.map((e) => e),
    finalAutoQC: filterDataBau.finalAutoQC?.map((e) => e),
    pushedToFinalTable: filterDataBau.pushedToFinalTable?.map((e) => e),
    logMonth: filterDataBau.logMonth?.map((e) => e),
    exportId: [],
  };
  useEffect(() => {
    if (search.length > 0) {
      const timerId = setTimeout(() => {
        performSearch(search);
      }, 3000);
      return () => clearTimeout(timerId);
    } else {
      setPage(1);

      getSource(1, limit, search, filterBody);
    }
  }, [search]);

  const performSearch = (value) => {
    setPage(1);
    let encodedValue = encodeURIComponent(value);

    getSource(1, limit, encodedValue, filterBody);
  };
  useEffect(() => {
    if (searchBau.length > 0) {
      const timerId = setTimeout(() => {
        performSearchBau(searchBau);
      }, 3000);
      return () => clearTimeout(timerId);
    } else {
      setPageBau(1);

      getBAU(1, limitBau, searchBau, filterBodyBau);
    }
  }, [searchBau]);

  const performSearchBau = (value) => {
    setPageBau(1);
    let encodedValue = encodeURIComponent(value);

    getBAU(1, limitBau, encodedValue, filterBodyBau);
  };

  /******************************************************************************
  Function: getSource
  Argument: page,limit,search,body
  Return: 
  Usage:
  1.To call grid API
  *******************************************************************************/

  const getSource = (
    page,
    limit,
    search,
    body = {
      region: [],
      rawProviderName: [],
      normalizedProviderName: [],
      exportId: [],
    }
  ) => {
    dispatch(getPoviderList(page, limit, search, body, id)).then((res) => {
      if (res) {
        setLoad(false);
        if (res.data.statusCode === statusCode.success) {
          if (res.data.result === qcReports.noRecordsFound) {
            settotalCount(0);
            settotalRecords(0);
            setData([]);
          } else {
            setData(res.data.result);
          }
          setLoad(false);

          settotal(res.data.result.length);
          setpageCount(Math.ceil(total / limit));
          settotalCount(res.data.total);
          settotalRecords(res.data.totalRecords);
        } else {
          settotalCount(0);
          settotalRecords(0);
          setData([]);
        }
      }
    });
  };
  const exportdata = selectExport.toString();
  const exportIds = exportdata.split(",");

  /******************************************************************************
  Function: handleExport
  Argument: body
  Return: 
  Usage:
  1.To Export data from grid
  *******************************************************************************/

  const handleExport = (body) => {
    setLoad(true);
    dispatch(
      getPoviderListExport(
        search,
        (body = {
          region: filterData.region,
          rawProviderName: filterData.rawProviderName,
          normalizedProviderName: filterData.normalizedProviderName,
          exportId: rows ? ["All"] : exportIds,
        }),
        id
      )
    ).then((res) => {
      setLoad(false);
      const wb = utils.book_new();
      const ws = utils.json_to_sheet([]);
      utils.sheet_add_aoa(ws, [
        [
          "ID",
          "Region",
          "Raw Provider Name",
          "Normalized Provider Name",
          "Comments",
          "Email Sent",
          "Email Sent Date",
        ],
      ]);
      const rows = res.data.result?.map((row) => [
        row.id,
        row.region,
        row.rawProviderName,
        row.normalizedProviderName,
        row.comment,
        row.emailSent,
        row.emailSentAt ? moment(row.emailSentAt).format("DD/MM/YYYY") : "",
      ]);
      utils.sheet_add_json(ws, rows, {
        origin: "A2",
        skipHeader: true,
      });

      utils.book_append_sheet(wb, ws, "Report");
      writeFile(
        wb,
        `provider_dictionary_status_${moment().format("DMMMyy")}.csv`
      );
    });
    getSource(page, limit, search, filterBody);
  };
  const exportdataBau = selectExportBau.toString();
  const exportIdsBau = exportdataBau.split(",");

  const handleExportBau = (body) => {
    setLoad(true);
    dispatch(
      getBAUListExport(
        search,
        (body = {
          bauId: filterDataBau.bauId?.map((e) => e),
          oemId: filterDataBau.oemId?.map((e) => e),
          make: filterDataBau.make?.map((e) => e),
          region: filterDataBau.region?.map((e) => e),
          uploaded: filterDataBau.uploaded?.map((e) => e),
          utf8Status: filterDataBau.utf8Status?.map((e) => e),
          qcStatus: filterDataBau.qcStatus?.map((e) => e),
          uploadStatusServiceBus: filterDataBau.uploadStatusServiceBus?.map(
            (e) => e
          ),
          finalAutoQC: filterDataBau.finalAutoQC?.map((e) => e),
          pushedToFinalTable: filterDataBau.pushedToFinalTable?.map((e) => e),
          logMonth: filterDataBau.logMonth?.map((e) => e),
          exportId: rowsBau ? ["All"] : exportIdsBau,
        }),
        id
      )
    ).then((res) => {
      setLoad(false);
      const wb = utils.book_new();
      const ws = utils.json_to_sheet([]);
      utils.sheet_add_aoa(ws, [
        [
          "BAU ID",
          "OEM ID",
          "Make",
          "Region",
          "Previous Start Date",
          "Previous End Date",
          "Current Start Date",
          "Current End Date",
          "DD Log Date",
          "DD Uploaded",
          "UTF8 Status",
          "Final Qc Status",
          "Upload Status Send To Servicebus",
          "File Sent For Final AutoQc",
          "Pushed To Final Table",
        ],
      ]);
      const rows = res.data.result?.map((row) => [
        row.bauid,
        row.oemId,
        row.make,
        row.region,
        row.previousStartDate
          ? moment(row.previousStartDate).format("DD/MM/YYYY")
          : "",
        row.previousEndDate
          ? moment(row.previousEndDate).format("DD/MM/YYYY")
          : "",
        row.currentStartDate
          ? moment(row.currentStartDate).format("DD/MM/YYYY")
          : "",
        row.currentEndDate
          ? moment(row.currentEndDate).format("DD/MM/YYYY")
          : "",
        row.ddLogDate ? moment(row.ddLogDate).format("DD/MM/YYYY") : "",
        row.ddUploaded,
        row.utf8Status,
        row.finalQcStatus,
        row.uploadStatusSendToServicebus,
        row.fileSentForFinalAutoQc,
        row.isPushedToFinalTable,
      ]);
      utils.sheet_add_json(ws, rows, {
        origin: "A2",
        skipHeader: true,
      });

      utils.book_append_sheet(wb, ws, "Report");
      writeFile(wb, `bau_status_report${moment().format("DMMMyy")}.csv`);
    });
    getBAU(pageBau, limitBau, searchBau, filterBodyBau);
  };
  const getBAU = (
    page,
    limit,
    search,
    body = {
      bauId: [],
      oemId: [],
      make: [],
      region: [],
      uploaded: [],
      utf8Status: [],
      qcStatus: [],
      uploadStatusServiceBus: [],
      finalAutoQC: [],
      pushedToFinalTable: [],
      logMonth: [],
      exportId: [],
    }
  ) => {
    dispatch(getBAUList(page, limit, search, body, id)).then((res) => {
      if (res) {
        setLoad(false);
        if (res.data.statusCode === statusCode.success) {
          if (res.data.result === qcReports.noRecordsFound) {
            settotalCountBau(0);
            settotalRecordsBau(0);
            setBAUData([]);
          } else {
            setBAUData(res.data.result);
          }
          setLoad(false);

          settotalBau(res.data.result.length);
          setpageCountBau(Math.ceil(total / limit));
          settotalCountBau(res.data.total);
          settotalRecordsBau(res.data.totalRecords);
        } else {
          settotalCountBau(0);
          settotalRecordsBau(0);
          setBAUData([]);
        }
      }
    });
  };

  /******************************************************************************
  Function: filterSource
  Argument: data, reset 
  Return: 
  Usage:
  1.To Filter the grid data
  *******************************************************************************/

  const filterProvider = async (data, reset = false) => {
    setLoad(true);
    setPage(1);
    dispatch(getPoviderList(1, limit, search, data, id)).then((res) => {
      if (res) {
        setLoad(false);
        if (res.data.statusCode === statusCode.success) {
          if (res.data.result === qcReports.noRecordsFound) {
            settotalCount(0);
            settotalRecords(0);
            setData([]);
          } else {
            setData(res.data.result);
          }
          setLoad(false);
          //setState(res.data.result);
          if (!reset) {
            setAdvFilterOpen(false);
          }

          settotal(res.data.result.length);
          setpageCount(Math.ceil(total / limit));
          settotalCount(res.data.total);
          settotalRecords(res.data.totalRecords);
        } else if (res.data.statusCode === statusCode.notFound) {
          if (res.data.responseException.exceptionMessage.result === qcReports.noRecordsFound) {
            settotalCount(0);
            settotalRecords(0);
            setData([]);
          }
          setLoad(false);
          if (!reset) {
            setAdvFilterOpen(false);
          }
        }
      }
    });
  };
  const filterBau = async (data, reset = false) => {
    setLoad(true);
    setPageBau(1);
    dispatch(getBAUList(1, limitBau, searchBau, data, id)).then((res) => {
      if (res) {
        setLoad(false);
        if (res.data.statusCode === statusCode.success) {
          if (res.data.result === qcReports.noRecordsFound) {
            settotalCountBau(0);
            settotalRecordsBau(0);
            setBAUData([]);
          } else {
            setBAUData(res.data.result);
          }
          setLoad(false);
          if (!reset) {
            setAdvFilterOpenBau(false);
          }

          settotalBau(res.data.result.length);
          setpageCountBau(Math.ceil(total / limit));
          settotalCountBau(res.data.total);
          settotalRecordsBau(res.data.totalRecords);
        } else if (res.data.statusCode === statusCode.notFound) {
          if (res.data.responseException.exceptionMessage.result === qcReports.noRecordsFound) {
            settotalCountBau(0);
            settotalRecordsBau(0);
            setBAUData([]);
          }
          if (!reset) {
            setAdvFilterOpenBau(false);
          }
        }
      }
    });
  };
  const handleInputChange = (e) => {
    const value = e.target.value;
    setSearch(value);
  };
  const handleInputChangeBau = (e) => {
    const value = e.target.value;
    setSearchBau(value);
  };

  useEffect(() => {
    getSource(page, limit, "");
    dispatch(
      setProviderFilter({
        region: [],
        rawProviderName: [],
        normalizedProviderName: [],

        exportId: [],
      })
    );
    dispatch(
      setBauFilter({
        bauId: [],
        oemId: [],
        make: [],
        region: [],
        uploaded: [],
        utf8Status: [],
        qcStatus: [],
        uploadStatusServiceBus: [],
        finalAutoQC: [],
        pushedToFinalTable: [],
        logMonth: [],
        exportId: [],
      })
    );
    getBAU(pageBau, limitBau, "");
    setAdd(
      selector &&
        selector.roleConfigurations.filter((e) =>
          e.menuName === qcReports.menuName
            ? location.pathname === qcReports.locationName && e.isAdd === true
            : e.menuName.replace("&", "and").toLowerCase() ===
                location.pathname
                  .replace("/", "")
                  .replace("-", " ")
                  .replace("-", " ")
                  .replace("/", "#")
                  .split("#")[0] && e.isAdd === true
        )
    );
    setEdit(
      selector &&
        selector.roleConfigurations.filter((e) =>
          e.menuName === qcReports.menuName
            ? location.pathname === qcReports.locationName && e.isEdit === true
            : e.menuName.replace("&", "and").toLowerCase() ===
                location.pathname
                  .replace("/", "")
                  .replace("-", " ")
                  .replace("-", " ")
                  .replace("/", "#")
                  .split("#")[0] && e.isEdit === true
        )
    );
  }, [id]);

  /******************************************************************************
  Function: handleSelect
  Argument: row
  Return:
  Usage:
  1.To select rows to export
  *******************************************************************************/
  const validRowLengths = [10, 15, 25, 50, 100];
  const handleSelect = async (row) => {
    setselectExport(row?.map((e) => e.id));

    setRows(validRowLengths.includes(row.length));
    if (row.length === 0) {
      setShow(false);
    } else {
      setShow(true);
    }
  };
  const handleSelectBau = async (row) => {
    setselectExportBau(row?.map((e) => e.bauid));
    setRowsBau(validRowLengths.includes(row.length));
    if (row.length === 0) {
      setshowBAU(false);
    } else {
      setshowBAU(true);
    }
  };

  /******************************************************************************
  Function: handlePageClick
  Argument: event, data
  Return:
  Usage:
  1.To handle page navigation
  *******************************************************************************/

  const handlePageClick = async (event, data) => {
    setLoad(true);
    setPage(data);
    await getSource(data, limit, search, filterBody);
    gridApi.current.redrawRows(data);
  };

  const handlePageClickBau = async (event, data) => {
    setLoad(true);
    setPageBau(data);
    await getBAU(data, limitBau, searchBau, filterBodyBau);
    gridApi.current.redrawRows(bauData);
  };
  const [gridKey, setGridKey] = useState(0);
  const resetAll = async () => {
    dispatch(
      setProviderFilter({
        region: [],
        rawProviderName: [],
        normalizedProviderName: [],
        exportId: [],
      })
    );
    // increment the grid key to force a re-render
    setGridKey(gridKey + 1);
    if (search !== "") {
      setPage(1);
      setSearch("");
    }
    getSource(1, limit, "", {
      region: [],
      rawProviderName: [],
      normalizedProviderName: [],

      exportId: [],
    });
    // increment the grid key to force a re-render
    setGridKey(gridKey + 1);
  };
  const [gridKeyBau, setGridKeyBau] = useState(0);

  const resetAllBau = async () => {
    dispatch(
      setBauFilter({
        bauId: [],
        oemId: [],
        make: [],
        region: [],
        uploaded: [],
        utf8Status: [],
        qcStatus: [],
        uploadStatusServiceBus: [],
        finalAutoQC: [],
        pushedToFinalTable: [],
        logMonth: [],
        exportId: [],
      })
    );
    // increment the grid key to force a re-render
    setGridKeyBau(gridKeyBau + 1);
    if (searchBau !== "") {
      setPageBau(1);
      setSearchBau("");
    }
    getBAU(1, limitBau, "", {
      bauId: [],
      oemId: [],
      make: [],
      region: [],
      uploaded: [],
      utf8Status: [],
      qcStatus: [],
      uploadStatusServiceBus: [],
      finalAutoQC: [],
      pushedToFinalTable: [],
      logMonth: [],
      exportId: [],
    });
    // increment the grid key to force a re-render
    setGridKeyBau(gridKeyBau + 1);
  };

  const [value, setValue] = React.useState("1");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <div>
      {/* Manage Issues Page Start Here */}
      <Box>
        <Spinner open={load} />
        {/* BaseLayout Start Here */}
        <BaseLayout>
          <Box sx={{ width: "100%", typography: "body1" }}>
            <TabContext value={value}>
              <Box>
                <TabList
                  centered
                  textColor="primary"
                  indicatorColor="primary"
                  onChange={handleChange}
                  aria-label="lab API tabs example"
                >
                  <Tab label="Provider Dictionary Status" value="1" />
                  <Tab label="BAU Status Report" value="2" />
                </TabList>
              </Box>
              <TabPanel value="1">
                {/* Action Area - Search by Keyword, Total Record Count, Add Issue, Adv. Filter and Export */}
                <Grid
                  container
                  spacing={2}
                  className={classes.pageActionArea}
                  alignItems="center"
                  justifyContent="flex-start"
                >
                  <Grid item xs={12} md={5}>
                    <Grid
                      container
                      alignItems="center"
                      justifyContent="left"
                      spacing={2}
                    >
                      <Grid item xs={"auto"}>
                        <Gridnav onChange={handleInputChange} data={search} />
                      </Grid>
                      <Grid item xs={"auto"}>
                        <Typography
                          variant="caption"
                          display="block"
                          gutterBottom
                          className={classes.totalResults}
                        >
                          Total Results:{" "}
                          <span className={classes.totalValue}>
                            {totalRecords ?? 0}
                          </span>
                          &nbsp;
                          <span className={classes.recordText}>Records</span>
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12} md={7}>
                    <Grid
                      container
                      spacing={1.75}
                      justifyContent="flex-end"
                      alignItems="flex-end"
                    >
                      <Grid item xs={"auto"}>
                        <MaterialUIButton
                          variant="outlined"
                          message="Clear Filters"
                          startIcon={<RestartAltIcon />}
                          onClick={() => resetAll()}
                        />
                      </Grid>

                      <Grid item xs={"auto"}>
                        <MaterialUIButton
                          variant="outlined"
                          onClick={() => setAdvFilterOpen(true)}
                          message="Advance Filter"
                          startIcon={<FilterListOutlinedIcon />}
                        />
                      </Grid>

                      <Grid item xs={"auto"}>
                        <MaterialUIButton
                          variant="outlined"
                          message="Export"
                          disabled={!show}
                          onClick={() => {
                            handleExport();
                            setShow(false);
                          }}
                          startIcon={<FileDownloadOutlinedIcon />}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>

                {/* Grid Start here */}
                <Grid
                  container
                  spacing={2}
                  className={classes.pageActionArea}
                  alignItems="center"
                  justifyContent="flex-start"
                  sx={{ p: 0 }}
                >
                  <Grid item xs={12} className={classes.fullHeight}>
                    <AgGrid
                      data={Data}
                      header={header}
                      selectAll={handleSelect}
                      key={gridKey}
                    />
                    <UsePagination
                      pageCount={pageCount}
                      count={total}
                      t={totalRecords}
                      total={totalCount}
                      currentPage={page}
                      limit={limit}
                      value={limit}
                      handlePageClick={handlePageClick}
                      onChange={(e) => {
                        setLimit(e.target.value);
                        setPage(1);
                        getSource(1, e.target.value, search, filterBody);
                        // gridApi.current.redrawRows(select.reportsdata);
                      }}
                    />
                  </Grid>
                </Grid>
              </TabPanel>
              <TabPanel value="2">
                {" "}
                {/* Action Area - Search by Keyword, Total Record Count, Add Issue, Adv. Filter and Export */}
                <Grid
                  container
                  spacing={2}
                  className={classes.pageActionArea}
                  alignItems="center"
                  justifyContent="flex-start"
                >
                  <Grid item xs={12} md={5}>
                    <Grid
                      container
                      alignItems="center"
                      justifyContent="left"
                      spacing={2}
                    >
                      <Grid item xs={"auto"}>
                        <Gridnav
                          onChange={handleInputChangeBau}
                          data={searchBau}
                        />
                      </Grid>
                      <Grid item xs={"auto"}>
                        <Typography
                          variant="caption"
                          display="block"
                          gutterBottom
                          className={classes.totalResults}
                        >
                          Total Results:{" "}
                          <span className={classes.totalValue}>
                            {totalRecordsBau ?? 0}
                          </span>
                          &nbsp;
                          <span className={classes.recordText}>Records</span>
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12} md={7}>
                    <Grid
                      container
                      spacing={1.75}
                      justifyContent="flex-end"
                      alignItems="flex-end"
                    >
                      <Grid item xs={"auto"}>
                        <MaterialUIButton
                          variant="outlined"
                          message="Clear Filters"
                          startIcon={<RestartAltIcon />}
                          onClick={() => resetAllBau()}
                        />
                      </Grid>

                      <Grid item xs={"auto"}>
                        <MaterialUIButton
                          variant="outlined"
                          onClick={() => setAdvFilterOpenBau(true)}
                          message="Advance Filter"
                          startIcon={<FilterListOutlinedIcon />}
                        />
                      </Grid>

                      <Grid item xs={"auto"}>
                        <MaterialUIButton
                          variant="outlined"
                          disabled={!showBAU}
                          message="Export"
                          onClick={() => {
                            handleExportBau();
                            setshowBAU(false);
                          }}
                          startIcon={<FileDownloadOutlinedIcon />}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                {/* Grid Start here */}
                <Grid
                  container
                  spacing={2}
                  className={classes.pageActionArea}
                  alignItems="center"
                  justifyContent="flex-start"
                  sx={{ p: 0 }}
                >
                  <Grid item xs={12} className={classes.fullHeight}>
                    <AgGrid
                      data={bauData}
                      header={headerBau}
                      selectAll={handleSelectBau}
                      key={gridKey}
                    />
                    <UsePagination
                      pageCount={pageCountBau}
                      count={totalBau}
                      t={totalRecordsBau}
                      total={totalCountBau}
                      currentPage={pageBau}
                      limit={limitBau}
                      value={limitBau}
                      handlePageClick={handlePageClickBau}
                      onChange={(e) => {
                        setLimitBau(e.target.value);
                        setPageBau(1);
                        getBAU(1, e.target.value, searchBau, filterBodyBau);
                      }}
                    />
                  </Grid>
                </Grid>
              </TabPanel>
            </TabContext>
          </Box>
        </BaseLayout>

        {/* Advance Filter Model */}
        <MaterialUIModal
          open={advFilterOpen}
          anchor="right"
          body={
            <AdvanceFilters
              filter={filterProvider}
              close={() => setAdvFilterOpen(false)}
            />
          }
        />
        <MaterialUIModal
          open={advFilterOpenBau}
          anchor="right"
          body={
            <AdvanceFilterBau
              filter={filterBau}
              close={() => setAdvFilterOpenBau(false)}
            />
          }
        />
        <Toasts open={open} onClose={() => setOpen(false)} message={message} />
      </Box>
    </div>
  );
}

export default QcReports;
